<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formInventory">
      <div class="ps-2 pe-2 pb-1">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="deleteInventory()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="inventoryContract.userNameCreate"
              [createDate]="inventoryContract.createDate" [userNameUpdate]="inventoryContract.userNameUpdate"
              [updateDate]="inventoryContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="row align-items-end">
              <div class="col-lg-1 col-md-2 col-sm-2 col-12">
                <app-custom-input-number formControlName="code" [labelText]="'Código'" [required]="true"
                  [recovery]="true" (onChangeNumber)="changeInventory()"></app-custom-input-number>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-5 col-12">
                <app-custom-input-text formControlName="name" [labelText]="'Nombre'"
                  [maxLength]="500"></app-custom-input-text>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-5 col-12">
                <app-custom-select formControlName="typeInventoryId" [labelText]="'Tipo'" [list]="listTypeInventories"
                  [required]="true"></app-custom-select>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-5 col-12">
                <app-custom-select formControlName="inventoryClassId" [labelText]="'Clase'"
                  [list]="listClassInventories" [required]="true"></app-custom-select>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-6 col-12 checkbox-localCosting">
                <app-custom-checkbox formControlName="localCosting" [labelText]="'Costeo Local'"></app-custom-checkbox>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-6 col-12 checkbox-swInternalOrder" *ngIf="isASADMIN">
                <app-custom-checkbox formControlName="swInternalOrder"
                  [labelText]="'Maneja Ped.Int.'"></app-custom-checkbox>
              </div>
              <!-- Botones en la misma fila -->
              <div class="container-btns mt-2">
                <div class="d-flex gap-2">
                  <app-custom-button [title]="'Asignar Usuarios'" [label]="'Asignar Usuarios'" [width]="'8.5rem'"
                    [severity]="'success'" [disabled]="isButtonDisabled" (onClick)="openModal()">
                  </app-custom-button>
                  <app-custom-modal #inventoryUserModal [label]="'Asignar Usuarios'" [header]="'Asignar Usuarios'"
                    [width]="'65rem'" [inputs$]="inputsForInventoryUserModals$" [children]="componentInventoryUserModal"
                    hidden>
                  </app-custom-modal>
                  <app-custom-button [disabled]="disabledForm" [title]="'Guardar'" [label]="'Guardar'"
                    (onClick)="send()">
                  </app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>